<template>
  <div class="flex flex-col w-full">
    <div class="border-gray-300 border-solid border-b-2"
      v-if="showHeader">
      Config
    </div>
    <UserConfig
      :defaultValue="defaultValue?.userConfig"
      v-model="formValues.userConfig"
    />
    <AppMetadata
      :defaultValue="defaultValue?.appMetadata"
      v-model="formValues.appMetadata"
    />
  </div>
</template>


<script>
import UserConfig from './UserConfig/UserConfig.vue'
import AppMetadata from './UserConfig/AppMetadata.vue'


export default {
  components: {
    UserConfig,
    AppMetadata,
  },
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
    value: undefined,
    defaultValue: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      formValues: {
        userConfig: undefined,
        appMetadata: undefined,
      },
    }
  },
  mounted() {
    if (this.defaultValue) {
      this.formValues = this.defaultValue
    }
  },
  methods: {
    updateValue() {
      this.$emit('input', this.formValues)
    },
  },
  watch: {
    value(newValue) {
      this.formValues = newValue
    },
    formValues: {
      handler() {
        this.updateValue()
      },
      deep: true,
    },
    defaultValue(newValue) {
      this.formValues = newValue
    }
  }
}
</script>
